import React from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { Href, IotDeveloper, UXDesigner, WebDesigner } from "../../../../Constants/Constants";
import { SimpleNavProps } from "../../../../Types/UiKitsType";

const JustifyNav: React.FC<SimpleNavProps> = ({ basicTab, setBasicTab }) => {
  return (
    <Nav className="border-0 nav-warning" color="primary" pills>
      <NavItem>
        <NavLink href={Href} className={`${basicTab === "1" ? "active" : ""}`} onClick={() => setBasicTab("1")}>
          {WebDesigner}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`${basicTab === "2" ? "active" : ""}`} onClick={() => setBasicTab("2")}>
          {UXDesigner}
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink href={Href} className={`${basicTab === "3" ? "active" : ""}`} onClick={() => setBasicTab("3")}>
          {IotDeveloper}
        </NavLink>
      </NavItem>
    </Nav>
  );
};

export default JustifyNav;
